export class DNSValidationError extends Error {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, DNSValidationError.prototype);
  }
}
